<template>
  <div id="app">
      <rentalCalc/>
  </div>
</template>

<script>
import rentalCalc from './components/rentalCalc.vue'

export default {
  name: 'App',
  components: {
    rentalCalc
  }
}
</script>
